import React from "react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2C4C3B] text-[#FDFBF7] py-16 px-6 lg:px-10"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="font-display text-2xl tracking-tight">
            Thai Tasty Treats
          </div>
          <p className="mt-3 text-sm text-[#FDFBF7]/70 max-w-xs">
            Small-batch Thai-style iced beverages, brewed by hand and bottled
            with love.
          </p>
        </div>
        <div className="text-sm text-[#FDFBF7]/80 space-y-2">
          <div className="uppercase tracking-widest text-[10px] text-[#FDFBF7]/60 mb-3">
            Contact
          </div>
          <div>P.Nong@ThaiTastyTreats.com</div>
          <div>352-552-4074</div>
          <div>ThaiTastyTreats.com</div>
        </div>
        <div className="text-sm text-[#FDFBF7]/80 space-y-2">
          <div className="uppercase tracking-widest text-[10px] text-[#FDFBF7]/60 mb-3">
            Fulfillment
          </div>
          <div>Local pickup &middot; Florida</div>
          <div>Free local delivery</div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-[#FDFBF7]/15 text-xs text-[#FDFBF7]/60 flex flex-col sm:flex-row justify-between gap-3">
        <div>© {new Date().getFullYear()} Thai Tasty Treats. All rights reserved.</div>
        <div className="flex items-center gap-4">
          <a
            href="/orders/lookup"
            data-testid="footer-order-lookup-link"
            className="hover:text-[#FDFBF7] transition-colors"
          >
            Track an order
          </a>
          <span className="opacity-50">Made with care in Florida.</span>
        </div>
      </div>
    </footer>
  );
}
